(function () {
  const settings = {
    keyword: 'buy more save more',
    debug: false,
    currencySelectors: '.header__icons [data-currency-converter], .header__icons #currency-convertor, .modal_area [data-currency-converter], .modal_area [data-native-currency-converter], [data-currency-converter], #currency-convertor',
    css: `
      .product-form__item.pb_selectable.boxes .btn[data-wr-volume-injected] {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        height: auto !important;
      }
      .product-form__item.pb_selectable.boxes .wr-column-qty {
        display: block;
        font-weight: 600;
      }
      .product-form__item.pb_selectable.boxes .wr-volume-unit-price {
        display: block;
        color: #79797b;
        font-weight: 400;
        line-height: 16px;
        font-size: 14px;
        white-space: nowrap;
      }
    `
  };

  const QTY_UNIT_PATTERN = /^(\d+)\s*(pc|pack|item|pair)s?\b/i;
  let productDetails = null;
  let activeVariantId = null;
  let isActive = true;

  function isVolumePricingOption(name) {
    return String(name || '').toLowerCase().includes(settings.keyword);
  }

  function extractQtyInfo(optionValue) {
    const match = String(optionValue).trim().match(QTY_UNIT_PATTERN);
    if (!match) return null;
    const qty = parseInt(match[1], 10);
    if (qty < 1) return null;
    const unit = match[2].toLowerCase();
    return {
      quantity: qty,
      qtyLabel: (qty === 1 ? `1 ${unit}` : `${qty} ${unit}s`).toUpperCase(),
      suffix: `/${unit}`,
    };
  }

  function getCurrentVariantId() {
    if (activeVariantId) return activeVariantId;
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput?.value) return idInput.value;
    return window.ShopifyAnalytics?.meta?.selectedVariantId || window.meta?.product?.selectedVariantId;
  }

  function buildPriceMap() {
    if (!productDetails) return null;
    const currentId = getCurrentVariantId();
    if (!currentId) return null;

    const currentVariant = productDetails.variants.find(v => String(v.id) === String(currentId));
    if (!currentVariant) return null;

    const optionIndex = productDetails.options.findIndex(opt => {
      const name = typeof opt === 'string' ? opt : opt?.name;
      return isVolumePricingOption(name);
    });
    if (optionIndex < 0) { isActive = false; return null; }

    const pricingKey = `option${optionIndex + 1}`;
    let baseKey = null;
    if (productDetails.options.length > 1) {
      const baseIndex = productDetails.options.findIndex(opt => {
        const name = typeof opt === 'string' ? opt : opt?.name;
        return String(name || '').toLowerCase().includes('product');
      });
      if (baseIndex >= 0 && `option${baseIndex + 1}` !== pricingKey) {
        baseKey = `option${baseIndex + 1}`;
      } else if (pricingKey !== 'option1') {
        baseKey = 'option1';
      }
    }

    const bestMatches = new Map();
    for (const variant of productDetails.variants) {
      if (baseKey) {
        if (String(variant[baseKey] || '').trim().toLowerCase() !== String(currentVariant[baseKey] || '').trim().toLowerCase()) continue;
      }
      const optVal = variant[pricingKey];
      if (!optVal) continue;
      let score = 0;
      for (let i = 0; i < productDetails.options.length; i++) {
        const k = `option${i + 1}`;
        if (k !== pricingKey && k !== baseKey) {
          if (String(variant[k] || '').trim().toLowerCase() === String(currentVariant[k] || '').trim().toLowerCase()) score++;
        }
      }
      const existing = bestMatches.get(optVal);
      if (!existing || score > existing.score) bestMatches.set(optVal, { variant, score });
    }

    const priceMap = new Map();
    for (const [optVal, { variant }] of bestMatches) {
      const qtyInfo = extractQtyInfo(optVal);
      if (!qtyInfo) continue;
      const raw = Number(variant.price);
      if (!Number.isFinite(raw) || raw <= 0) continue;
      const totalCents = String(variant.price).includes('.') ? Math.round(raw * 100) : Math.round(raw);
      if (totalCents <= 0) continue;
      priceMap.set(optVal, {
        unitCents: Math.round(totalCents / qtyInfo.quantity),
        qtyLabel: qtyInfo.qtyLabel,
        suffix: qtyInfo.suffix,
      });
    }

    return priceMap.size > 0 ? { priceMap, baseCurrency: window.Shopify?.currency?.active || 'USD' } : null;
  }

  function normalizedLookup(priceMap, key) {
    const norm = String(key || '').trim().toLowerCase();
    for (const [k, v] of priceMap) {
      if (String(k).trim().toLowerCase() === norm) return v;
    }
    return null;
  }

  function formatPrice(cents, currency) {
    if (currency === 'VND') return `${Math.round(cents).toLocaleString('vi-VN')}₫`;
    return `$${(cents / 100).toFixed(2)} USD`;
  }

  function applyLabels() {
    if (!isActive) return;
    const config = buildPriceMap();
    if (!config) return;

    const containers = document.querySelectorAll('.product-form__item.pb_selectable.boxes');
    let target = null;
    for (const c of containers) {
      const label = c.querySelector('label');
      if (label && isVolumePricingOption(label.textContent)) { target = c; break; }
    }
    if (!target) return;

    let changed = false;
    for (const btn of target.querySelectorAll('.buttons-group .btn')) {
      // Store original text before first modification
      if (!btn.dataset.wrOptionValue) {
        btn.dataset.wrOptionValue = btn.textContent.trim();
      }
      const details = normalizedLookup(config.priceMap, btn.dataset.wrOptionValue);
      if (!details) continue;

      const formatted = formatPrice(details.unitCents, config.baseCurrency);
      if (btn.dataset.wrVolumeInjected === '1' && btn.dataset.wrBasePrice === formatted) continue;

      btn.replaceChildren();

      const qtySpan = document.createElement('span');
      qtySpan.className = 'wr-column-qty';
      qtySpan.textContent = details.qtyLabel;

      const priceSpan = document.createElement('span');
      priceSpan.className = 'wr-volume-unit-price';

      const moneySpan = document.createElement('span');
      moneySpan.className = 'money';
      moneySpan.setAttribute(`data-currency-${config.baseCurrency}`, formatted);
      moneySpan.textContent = formatted;

      priceSpan.append(moneySpan, document.createTextNode(details.suffix));
      btn.append(qtySpan, priceSpan);
      btn.dataset.wrVolumeInjected = '1';
      btn.dataset.wrBasePrice = formatted;
      changed = true;
    }

    if (changed && window.Currency?.convertAll) {
      const active = window.Currency.currentCurrency || config.baseCurrency;
      if (active !== config.baseCurrency) {
        try { window.Currency.convertAll(config.baseCurrency, active, '.wr-volume-unit-price .money'); }
        catch (e) { console.error('[WR]', e); }
      }
    }
  }

  async function loadProduct() {
    try {
      const match = window.location.pathname.match(/\/products\/([^\/]+)/);
      if (!match) return;
      const res = await fetch(`/products/${match[1]}.js`);
      if (!res.ok) return;
      productDetails = await res.json();
      applyLabels();
    } catch (e) {
      console.error('[WR] Failed to load product:', e);
    }
  }

  // Inject styles
  if (!document.getElementById('customall-volume-pricing-style')) {
    const style = document.createElement('style');
    style.id = 'customall-volume-pricing-style';
    style.textContent = settings.css;
    document.head.appendChild(style);
  }

  // Pre-check: skip entirely if product has no volume pricing option
  (function () {
    const options = window.meta?.product?.options || window._MP_CONFIG_?.product?.options;
    if (options?.length && !options.some(isVolumePricingOption)) isActive = false;
  })();

  if (isActive) loadProduct();

  // Watch .product-attributes for DOM changes (Vue re-renders, lazy mount)
  let domDebounce;
  const domObserver = new MutationObserver(() => {
    if (!isActive || !productDetails) return;
    clearTimeout(domDebounce);
    domDebounce = setTimeout(applyLabels, 100);
  });

  function startObserving() {
    const container = document.querySelector('.product-attributes');
    if (container) {
      domObserver.observe(container, { childList: true, subtree: true });
      applyLabels();
    } else {
      const waitObserver = new MutationObserver(() => {
        const c = document.querySelector('.product-attributes');
        if (c) {
          waitObserver.disconnect();
          domObserver.observe(c, { childList: true, subtree: true });
          applyLabels();
        }
      });
      waitObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // Variant & currency change handlers
  document.addEventListener('change', (e) => {
    if (!isActive) return;
    if (e.target?.closest('form[action*="/cart/add"]') && e.target.name === 'id') {
      activeVariantId = e.target.value;
      setTimeout(applyLabels, 50);
    }
    if (e.target?.matches(settings.currencySelectors)) {
      setTimeout(applyLabels, 150);
    }
  });

  document.addEventListener('variant:changed', () => {
    if (!isActive) return;
    activeVariantId = null;
    setTimeout(applyLabels, 100);
  });
})();
